import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchPreviewUrls } from "actions";
import Loading from "../components/Loading";

import "css/ImageResolver.css";
import ImgWithSrcset from '../components/ImgWithSrcset';

class ImageResolver extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            imagesToLoad: 1
        };
    }
    componentDidMount() {
        let { query, handles } = this.props;

        // delay it, so it only fetchs after the start of the animation between pages
        if (query) setTimeout(() => this.props.fetchPreviewUrls(query, null, handles), 500);
    }

    getImageList(props) {
        let { filters, previews, previousPreviews } = props;

        if (!Array.isArray(filters)) {
            filters = [filters];
        }

        let previewList = [];

        for (let i = 0; i < filters.length; i++) {
            previewList = previewList.concat(
                previews.filter(p => {
                    for (let filter in filters[i]) {
                        if (p[filter] !== filters[i][filter]) {
                            return false;
                        }
                    }
                    return true;
                })
            );
        }

        var images = [];

        for (let i = 1; i <= 8; i++) {
            let previousPreview = previousPreviews.filter(pp => pp.rank === i)[0];
            if (previousPreview && previousPreview.src)
                images[i] = "https://s3-eu-west-1.amazonaws.com/truframe/" + previousPreview.src;
        }

        for (let n = 0; n < previewList.length; n++) {
            for (var i = 1; i <= 8; i++) {
                var src = previewList[n]["url" + i];
                if (src) images[i] = "https://s3-eu-west-1.amazonaws.com/truframe/" + src;
            }
        }

        return images;
    }

    componentWillReceiveProps(nextProps) {
        var images = this.getImageList(nextProps);

        var currentImages = this.getImageList(this.props);

        // remove empty images
        images = images.filter(i => !!i);
        currentImages = currentImages.filter(i => !!i);

        // keep only the images that aren't already loaded
        images = images.filter(i => currentImages.indexOf(i) === -1);

        var imageCount = images.length;

        // if the filters haven't changed, ignore this
        if (
            JSON.stringify(this.props.filters) === JSON.stringify(nextProps.filters) ||
            imageCount === 0
        )
            return;

        this.setState({ loading: imageCount !== 0, imagesToLoad: imageCount });
    }

    imageLoaded() {
        var { imagesToLoad, loading } = this.state;

        imagesToLoad--;

        if (imagesToLoad === 0) {
            loading = false;
        }

        this.setState({ imagesToLoad, loading });
    }

    render() {
        var images = this.getImageList(this.props);

        if (images.length === 0) {
            return <Loading />;
        }

        let loading = this.state.loading;

        if (this.props.useLoadingFeature !== true) loading = false;

        return (
            <div className="ImageResolver">
                <div style={{ display: loading ? "block" : "none" }}>
                    <Loading text={null} />
                </div>
                <div
                    style={{
                        position: "relative",
                        display: loading ? "none" : "block"
                    }}
                >
                    {images.map((src, index) => (
                        <ImgWithSrcset key={index} src={src} alt="" onLoad={this.imageLoaded.bind(this)} />
                    ))}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        previews: state.PreviewImages,
        previousPreviews: state.PreviousPreviews
    };
};

export default connect(mapStateToProps, { fetchPreviewUrls })(ImageResolver);



// WEBPACK FOOTER //
// ./src/containers/ImageResolver.js